import {
    actionTypes as asyncTypes, isAsyncComplete, isAsyncOperation,
 } from "async-ops";
import { cloneDeep } from "lodash";
import { GET_ESMD_SUBMISSSIONS } from "../../../../common_components/case-details/esMd-dashboard/services/get-esmd-submission";
import { GET_CASE_CLAIM_DETAILS } from "../../../../common_components/case-details/services/get-case-claim-details";
import { GET_ALIAS_BILL_DATA_FIELDS } from "../../../../pages/customer-setup/data-configuration/services/get-alias-bill-data-fields";

import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../../common_components/mdae-framework";
export const TOGGLE_CASE_DETAIL_POPUP = "TOGGLE_CASE_DETAIL_POPUP";
export const SET_CASE_DETAIL_DATA = "SET_CASE_DETAIL_DATA";
export const TOGGLE_CASE_DETAIL_WARNING_POPUP =
  "TOGGLE_CASE_DETAIL_WARNING_POPUP";
export const SAVE_AND_CLOSE_BUTTON_CLICKABLE =
  "SAVE_AND_CLOSE_BUTTON_CLICKABLE";
export const SET_EA_CASE_DETAIL_TAB_VISIBLE = "SET_EA_CASE_DETAIL_TAB_VISIBLE";
export const SET_IS_CASE_DOCUMENT_COUNT_SEEN =
  "SET_IS_CASE_DOCUMENT_COUNT_SEEN";
export const SET_DOCUMENT_COUNT_PROPERTY = "SET_DOCUMENT_COUNT_PROPERTY";
export const SET_REVIEW_CONTRACTOR_INVALID = "SET_REVIEW_CONTRACTOR_INVALID";
export const SET_COMPLETE_AUDIT_CASE_DETAIL = "SET_COMPLETE_AUDIT_CASE_DETAIL";
export const TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO = "TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO";
export const TOGGLE_MRN_TO_ALTERNATE_MRN = "TOGGLE_MRN_TO_ALTERNATE_MRN";
export const SHOW_ORIGINAL_ACCOUNT_NO = "SHOW_ORIGINAL_ACCOUNT_NO";
export const SHOW_ALTERNATE_MRN = "SHOW_ALTERNATE_MRN";
export const RESET_CASE_CLAIM_DETAILS = "RESET_CASE_CLAIM_DETAILS";
export const SET_CASE_DATA_SAVED = "SET_CASE_DATA_SAVED";
export const SET_MANUAL_EXPEDITE_CASE_SEARCH_COMPLETE_CASE_DETAIL = "SET_MANUAL_EXPEDITE_CASE_SEARCH_COMPLETE_CASE_DETAIL";

const initialError = {
  code: "",
  message: "",
  value: [],
};

export const initialCompleteCaseDetailData = {
  patientLastName: "",
  patientFirstName: "",
  patientMRN: "",
  patientAcctNo: "",
  dob: "",
};

const initialState = {
  isLoading: false,
  error: initialError,
  completeCaseDetail: initialCompleteCaseDetailData,
  codersUpdatedList: [],
  caseDetailData: {},
  excludedCoderList: [],
  aliasBillDataFields: [],
  eaCaseDetailsTabPanelSelectedIndex: 0,
  isCaseDataSaved: false,

};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_EA_CASE_DETAIL_TAB_VISIBLE:
    case RESET_CASE_CLAIM_DETAILS:
      return { ...state, ...action.data };
    case SAVE_AND_CLOSE_BUTTON_CLICKABLE:
    case TOGGLE_CASE_DETAIL_WARNING_POPUP:
    case TOGGLE_CASE_DETAIL_POPUP:
    case SET_CASE_DATA_SAVED:
    case SET_CASE_DETAIL_DATA:
    case SET_IS_CASE_DOCUMENT_COUNT_SEEN:
    case SET_DOCUMENT_COUNT_PROPERTY:
    case SET_REVIEW_CONTRACTOR_INVALID:
    case SET_COMPLETE_AUDIT_CASE_DETAIL:
    case TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO:
    case TOGGLE_MRN_TO_ALTERNATE_MRN:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncComplete(GET_CASE_CLAIM_DETAILS)(action)) {
        let auditCaseLines = action.response.auditCaseLines;
        action.response = {
          ...action.response,
          auditCaseLines: auditCaseLines.filter(
            (item) => item.parentCaseLineId === 0
          ),
          auditCaseLinesWithComponentRevenueCodes: auditCaseLines,
          isComponentRowsAvailable: auditCaseLines.some(
            (x) => x.parentCaseLineId > 0
          ),
        };
        return {
          ...state,
          completeCaseDetail: action.response,
        };
      }
      if (isAsyncComplete(GET_ESMD_SUBMISSSIONS)(action)) {
        return {
          ...state,
          esmdSubmissionList: action.response,
        };
          }
          if (isAsyncOperation(GET_ALIAS_BILL_DATA_FIELDS)(action)) {
              return {
                  ...state,
                  isLoading: true,
              };
          }

          if (isAsyncComplete(GET_ALIAS_BILL_DATA_FIELDS)(action)) {
              return {
                  ...state,
                  isLoading: false,
                  aliasBillDataFields: action.response,
              };
          }
      return state;
    case SET_MANUAL_EXPEDITE_CASE_SEARCH_COMPLETE_CASE_DETAIL:
      return {
        ...state,
        completeCaseDetail: action.data.completeCaseDetail,
      };
    default:
      return state;
  }
}
